export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  categoryName: string;
  date: string;
  readTime: string;
  image: string;
  content: string;
  tags: string[];
  author: string;
}

export const articles: Article[] = [
  {
    slug: "91cn-kuaisu-shangshou",
    title: "91.cn 新用户快速上手指南：五分钟掌握核心功能",
    excerpt: "刚注册 91.cn？这篇指南带你快速了解平台核心功能，从账号设置到服务开通，手把手教你完成第一步。",
    category: "zhinan",
    categoryName: "使用指南",
    date: "2026-07-28",
    readTime: "5 分钟",
    image: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20workspace%20with%20laptop%20displaying%20dashboard%20interface%20on%20a%20clean%20wooden%20desk%2C%20warm%20ambient%20lighting%2C%20coffee%20cup%20beside%20keyboard%2C%20soft%20natural%20light%20from%20window%2C%20professional%20yet%20welcoming%20atmosphere&width=800&height=450&seq=article-01&orientation=landscape",
    tags: ["新手入门", "快速上手", "教程"],
    author: "91.cn 产品团队",
    content: `<h2>欢迎来到 91.cn</h2><p>恭喜您完成 91.cn 的注册！作为新用户，您可能对平台的各种功能感到好奇。本文将在五分钟内，带您快速了解 91.cn 的核心功能，帮助您高效开启使用之旅。</p><h3>第一步：完善账号信息</h3><p>登录后，首先建议您前往「账号设置」页面，完善个人或企业信息。包括上传头像、设置昵称、绑定安全手机和邮箱等。完善的信息不仅能提升账号安全性，还能享受更个性化的服务推荐。</p><h3>第二步：了解服务面板</h3><p>91.cn 的服务面板是您使用平台的核心入口。在这里，您可以一目了然地看到所有已开通的服务、使用数据统计和待处理事项。建议您花两分钟熟悉面板布局，这将大大提高后续使用效率。</p><h3>第三步：开通所需服务</h3><p>在「服务市场」中，您可以浏览 91.cn 提供的全部服务模块。每个服务都有详细的功能介绍和使用案例。选择您需要的服务，点击「立即开通」即可开始使用。基础服务完全免费，高级功能可按需升级。</p><h3>第四步：安装桌面客户端（可选）</h3><p>如果您希望在电脑上获得更流畅的体验，可以下载 91.cn 桌面客户端。客户端支持离线使用、文件拖拽上传、消息推送等便捷功能，是重度用户的推荐选择。</p><h3>常见问题</h3><p>如果在使用过程中遇到任何问题，您可以随时点击页面右下角的「在线客服」按钮，我们的专业团队会在 30 秒内响应您的需求。</p>`,
  },
  {
    slug: "91cn-anquan-tixi",
    title: "深度解析 91.cn 安全防护体系：您的数据如何被保护",
    excerpt: "了解 91.cn 的多层次安全架构，从传输加密到存储保护，全方位了解平台如何守护您的数据安全。",
    category: "anquan",
    categoryName: "安全保障",
    date: "2026-07-25",
    readTime: "8 分钟",
    image: "https://readdy.ai/api/search-image?query=Abstract%20digital%20security%20concept%20with%20shield%20and%20lock%20icons%20floating%20in%20a%20clean%20minimal%20digital%20space%2C%20warm%20golden%20and%20white%20color%20palette%2C%20soft%20glowing%20data%20streams%2C%20modern%20tech%20illustration%20style&width=800&height=450&seq=article-02&orientation=landscape",
    tags: ["安全防护", "数据加密", "隐私保护"],
    author: "91.cn 安全团队",
    content: `<h2>91.cn 安全防护体系概述</h2><p>在数字化时代，数据安全是每个用户最关心的问题。91.cn 从平台创立之初就将安全作为核心基因，构建了业界领先的多层次安全防护体系。本文将为您详细解读这套体系的每一个环节。</p><h3>传输层安全：HTTPS/SSL 加密</h3><p>所有与 91.cn 服务器之间的数据传输均采用 HTTPS 协议和 SSL/TLS 加密通道。这意味着您在平台上执行的每一个操作——从登录、上传文件到发送消息——都经过了银行级别的加密保护，第三方无法窃听或篡改传输内容。</p><h3>存储层安全：AES-256 加密</h3><p>存储在 91.cn 服务器上的所有用户数据，均使用 AES-256 算法进行加密存储。AES-256 是目前公认最安全的对称加密标准之一，即使是超级计算机也需要数十亿年才能暴力破解。您的文件、消息和个人信息，在服务器上始终以密文形式存在。</p><h3>访问控制：多因素认证</h3><p>91.cn 支持多因素认证（MFA），您可以绑定手机验证码、邮箱验证码或认证器应用作为二次验证。即使密码意外泄露，攻击者也无法在没有第二因素的情况下登录您的账号。</p><h3>认证与合规</h3><p>91.cn 已通过 ISO 27001 信息安全管理体系认证，并严格遵循《中华人民共和国网络安全法》和《个人信息保护法》的相关要求。我们定期接受第三方安全审计机构的独立审查，确保安全措施始终符合国际标准。</p><h3>灾备与容灾</h3><p>平台采用「三地五中心」的分布式架构，所有数据实时同步至多个地理区域的数据中心。即使某一地区发生自然灾害或意外故障，您的数据也不会丢失，服务将在秒级自动切换至备份节点。</p>`,
  },
  {
    slug: "91cn-qiye-jieru",
    title: "企业用户如何高效接入 91.cn：完整对接方案与最佳实践",
    excerpt: "为企业用户量身定制的接入指南，涵盖 API 对接、SSO 单点登录、数据迁移等关键环节的详细说明。",
    category: "fuwu",
    categoryName: "服务介绍",
    date: "2026-07-22",
    readTime: "10 分钟",
    image: "https://readdy.ai/api/search-image?query=Modern%20corporate%20office%20setting%20with%20multiple%20monitors%20displaying%20data%20dashboards%20and%20charts%2C%20collaborative%20team%20environment%2C%20warm%20professional%20atmosphere%2C%20clean%20minimal%20design%20aesthetic&width=800&height=450&seq=article-03&orientation=landscape",
    tags: ["企业接入", "API对接", "SSO"],
    author: "91.cn 技术团队",
    content: `<h2>企业接入 91.cn 整体方案</h2><p>对于企业用户而言，高效、顺利地接入 91.cn 平台是发挥平台价值的第一步。本文将从技术对接、组织管理和数据迁移三个维度，为企业提供一套完整的接入方案和最佳实践。</p><h3>API 接口对接</h3><p>91.cn 提供丰富的 RESTful API 接口，覆盖用户管理、数据分析、文件存储等核心功能。所有接口均采用标准的 JSON 数据格式和 OAuth 2.0 认证协议。技术团队只需参考我们的 API 文档，即可在 1-3 个工作日内完成核心接口对接。</p><h3>SSO 单点登录集成</h3><p>91.cn 支持 SAML 2.0 和 OAuth 2.0 两种标准的单点登录协议，可与企业的现有身份认证系统无缝集成。员工无需额外记忆账号密码，使用企业统一账号即可登录 91.cn 平台，大大降低了账号管理的复杂度。</p><h3>数据迁移服务</h3><p>对于已有大量存量数据的企业，91.cn 提供免费的数据迁移服务。我们的技术团队会协助您制定迁移方案，使用专用的迁移工具确保数据完整、安全地转移至 91.cn 平台。整个迁移过程支持增量同步，不会影响业务的正常运行。</p><h3>专属客户成功经理</h3><p>所有企业客户均配备专属的客户成功经理，提供从接入规划、技术指导到后续优化的全程一对一服务。您的专属经理将在 48 小时内与您取得联系，共同制定最适合您企业的接入方案。</p>`,
  },
  {
    slug: "91cn-xin-gongneng-2026",
    title: "2026 年度 91.cn 重大功能更新：AI 智能助手与全新协作空间",
    excerpt: "91.cn 发布 2026 年度重磅更新，推出 AI 智能助手和全新团队协作空间，带来更智能更高效的使用体验。",
    category: "dongtai",
    categoryName: "平台动态",
    date: "2026-07-18",
    readTime: "6 分钟",
    image: "https://readdy.ai/api/search-image?query=Futuristic%20AI%20technology%20concept%20with%20holographic%20interface%20elements%20floating%20in%20a%20clean%20bright%20environment%2C%20warm%20golden%20accents%2C%20minimal%20and%20sophisticated%20design%2C%20soft%20ambient%20glow&width=800&height=450&seq=article-04&orientation=landscape",
    tags: ["功能更新", "AI助手", "协作空间"],
    author: "91.cn 产品团队",
    content: `<h2>2026 年度重磅更新发布</h2><p>我们很高兴地宣布，91.cn 2026 年度重大版本更新已于本月正式上线！本次更新围绕「智能」和「协作」两大核心主题，推出了多项备受期待的新功能。</p><h3>AI 智能助手</h3><p>全新的 AI 智能助手基于大语言模型技术，能够理解自然语言指令，帮助您高效完成各项操作。无论是数据分析报表的生成、文档内容的智能摘要，还是服务配置的自动推荐，AI 助手都能在几秒内完成，让您的工作效率翻倍。</p><h3>全新团队协作空间</h3><p>重新设计的团队协作空间支持实时多人编辑、在线白板、视频会议集成等功能。团队成员可以在统一的工作空间中无缝协作，告别在多个工具之间来回切换的烦恼。新空间还支持自定义工作流和自动化规则，让重复性工作自动完成。</p><h3>性能优化</h3><p>本次更新还对平台底层架构进行了全面优化，页面加载速度平均提升 45%，文件上传速度提升 60%，为所有用户带来更流畅的操作体验。</p>`,
  },
  {
    slug: "91cn-hezuo-jihua",
    title: "91.cn 开放平台合作计划：共建互联网服务新生态",
    excerpt: "了解 91.cn 开放平台的最新合作政策、技术标准与激励计划，携手打造互利共赢的服务生态。",
    category: "hezuo",
    categoryName: "合作生态",
    date: "2026-07-15",
    readTime: "7 分钟",
    image: "https://readdy.ai/api/search-image?query=Business%20partnership%20and%20ecosystem%20concept%20with%20interconnected%20geometric%20nodes%20and%20lines%20forming%20a%20network%2C%20warm%20professional%20color%20scheme%2C%20clean%20modern%20digital%20illustration%20style&width=800&height=450&seq=article-05&orientation=landscape",
    tags: ["开放平台", "合作计划", "生态建设"],
    author: "91.cn 商务团队",
    content: `<h2>91.cn 开放平台合作计划</h2><p>91.cn 始终坚持开放共赢的理念，致力于与合作伙伴共同打造繁荣的互联网服务生态。2026 年，我们推出了全新的开放平台合作计划，为各类合作伙伴提供更完善的技术支持和更优厚的商业回报。</p><h3>合作模式</h3><p>91.cn 开放平台支持三种合作模式：技术集成合作（通过 API/SDK 将第三方服务接入平台）、内容共建合作（联合产出高质量行业内容和解决方案）、渠道推广合作（通过互荐流量实现双赢增长）。合作伙伴可根据自身优势灵活选择。</p><h3>技术支持</h3><p>所有合作伙伴均可获得以下技术支持：完善的 API 文档和 SDK 工具包、沙箱测试环境、7×24 小时技术支持热线、定期技术交流会。确保合作伙伴能够快速、顺畅地完成技术对接。</p><h3>激励政策</h3><p>2026 年度合作伙伴激励计划已全面升级：优质合作伙伴可获得最高达 50% 的收入分成比例、季度优秀合作伙伴奖金、联合品牌推广资源、以及优先体验平台新功能的内测资格。</p>`,
  },
  {
    slug: "91cn-yinsi-zhengce",
    title: "91.cn 隐私保护政策详解：用户数据如何被合法合规使用",
    excerpt: "全面解读 91.cn 隐私政策的各项条款，让您清楚了解个人数据的收集、使用和保护方式。",
    category: "anquan",
    categoryName: "安全保障",
    date: "2026-07-10",
    readTime: "9 分钟",
    image: "https://readdy.ai/api/search-image?query=Privacy%20and%20data%20protection%20concept%20with%20document%20and%20shield%20symbols%20on%20a%20clean%20minimal%20background%2C%20warm%20and%20trustworthy%20visual%20style%2C%20soft%20lighting%2C%20professional%20atmosphere&width=800&height=450&seq=article-06&orientation=landscape",
    tags: ["隐私政策", "数据保护", "合规"],
    author: "91.cn 法务团队",
    content: `<h2>91.cn 隐私保护政策详解</h2><p>在 91.cn，我们深知用户隐私的重要性。本文将以通俗易懂的语言，帮助每一位用户全面了解 91.cn 隐私保护政策的核心内容，让您对个人数据的使用情况了如指掌。</p><h3>我们收集哪些数据</h3><p>91.cn 仅收集为您提供服务所必需的最小范围的数据，包括：账号注册信息（手机号或邮箱）、使用日志（用于优化服务体验）、设备基础信息（用于适配和排障）。我们绝不会收集与服务无关的个人敏感信息。</p><h3>数据如何使用</h3><p>您的数据仅用于以下明确目的：提供和优化平台服务、保障账号和交易安全、遵守法律法规要求。我们不会将您的数据出售给任何第三方，也不会用于任何未经您授权的商业用途。</p><h3>您的权利</h3><p>根据《个人信息保护法》，您享有查阅、更正、删除个人数据的权利，以及撤回同意和注销账号的权利。在 91.cn「账号设置-隐私中心」页面，您可以随时查看和管理您的数据授权状态。</p>`,
  },
  {
    slug: "91cn-shuju-fenxi",
    title: "玩转 91.cn 数据分析功能：从数据洞察到业务决策",
    excerpt: "深入讲解 91.cn 数据分析模块的各项功能，教你如何用数据驱动业务增长。",
    category: "zhinan",
    categoryName: "使用指南",
    date: "2026-07-05",
    readTime: "8 分钟",
    image: "https://readdy.ai/api/search-image?query=Data%20analytics%20dashboard%20displayed%20on%20a%20clean%20modern%20monitor%20with%20colorful%20charts%20and%20graphs%2C%20warm%20office%20lighting%2C%20minimal%20desk%20setup%2C%20professional%20yet%20approachable%20style&width=800&height=450&seq=article-07&orientation=landscape",
    tags: ["数据分析", "业务决策", "报表"],
    author: "91.cn 产品团队",
    content: `<h2>91.cn 数据分析功能全解析</h2><p>数据是数字时代最宝贵的资产。91.cn 内置了强大的数据分析引擎，帮助用户从海量数据中提取有价值的洞察。本文将全面介绍数据分析模块的各项功能和使用技巧。</p><h3>可视化报表</h3><p>91.cn 提供超过 30 种可视化图表类型，包括折线图、柱状图、饼图、热力图、漏斗图等。所有图表支持拖拽式配置，无需编程知识即可创建专业的分析报表。报表还支持一键导出为 PDF 或 Excel 格式。</p><h3>智能洞察</h3><p>AI 智能洞察功能会自动扫描您的数据，识别异常波动、趋势变化和潜在机会。当系统检测到值得关注的数据变化时，会主动向您推送洞察报告，帮助您第一时间发现问题和机遇。</p><h3>自定义看板</h3><p>您可以根据自身业务需求，创建个性化的数据看板。将最关键的指标集中展示在一个页面上，一目了然地掌握核心业务动态。看板支持实时刷新，数据延迟不超过 5 秒。</p>`,
  },
  {
    slug: "91cn-xiezuo-bangong",
    title: "91.cn 团队协作办公完全指南：效率提升的秘诀",
    excerpt: "从文档协作到项目管理，全面掌握 91.cn 协作办公套件的使用技巧，让团队协作效率倍增。",
    category: "zhinan",
    categoryName: "使用指南",
    date: "2026-06-28",
    readTime: "7 分钟",
    image: "https://readdy.ai/api/search-image?query=Modern%20team%20collaboration%20workspace%20with%20people%20working%20together%20around%20a%20large%20digital%20screen%2C%20bright%20warm%20lighting%2C%20clean%20minimal%20office%20design%2C%20professional%20atmosphere&width=800&height=450&seq=article-08&orientation=landscape",
    tags: ["协作办公", "团队管理", "效率提升"],
    author: "91.cn 产品团队",
    content: `<h2>91.cn 协作办公完全指南</h2><p>高效的团队协作是业务成功的基石。91.cn 协作办公套件集成了文档协作、任务管理、即时通讯和视频会议四大核心模块，为团队提供一站式的协作解决方案。</p><h3>文档协作</h3><p>91.cn 在线文档支持多人实时协同编辑，所有修改自动保存并支持完整的版本历史回溯。您可以为文档设置细粒度的权限控制，精确到段落级别的可见和编辑权限。内置的 AI 写作助手还能帮您润色文字、生成摘要和翻译内容。</p><h3>任务管理</h3><p>灵活的任务管理系统支持看板视图、列表视图和甘特图三种展示方式。您可以创建任务、指派负责人、设置截止日期和优先级，系统会自动跟踪任务进度并在关键节点发送提醒。支持与第三方日历（Google Calendar、Outlook）双向同步。</p><h3>即时通讯与视频会议</h3><p>内置的企业级即时通讯工具支持文字、语音、图片和文件消息，所有消息端到端加密。视频会议支持最多 500 人同时在线，提供屏幕共享、虚拟白板和会议录制功能。</p>`,
  },
];

export const getArticlesByCategory = (categorySlug: string): Article[] => {
  return articles.filter((article) => article.category === categorySlug);
};

export const getArticleBySlug = (slug: string): Article | undefined => {
  return articles.find((article) => article.slug === slug);
};

export const getCategoryName = (categorySlug: string): string => {
  const article = articles.find((a) => a.category === categorySlug);
  return article ? article.categoryName : categorySlug;
};